import { $,_,Marionette } from '../../vendor'

/**
 * @file behaviors/Behavior.SidebarFilter
 * @author Felix Albroscheit
 * 
 * @param { object } filterMap key-value pairs where key = ul[data-inb-filter]
 *                             and value is an onClickCallback accepting the view & filterValue
 * 
 * Manages the display of active/selected filters
 * in several sidebars (e.g. OrdersSidebarView)
 * by injecting custom html into #inb-selected-filters
 * 
 * @todo Refactor and documentate:
 * - Initial set collection-filters should be auto-activated (as in ContingentsSidebarView/OrdersSidebarView)
 * - Un-Jquery'fy
 * - Change (non-Backbone-compatible) approach towards injecting own template (this._render)
 */
export default Marionette.Behavior.extend({

  ui: {
    'container' : '#inb-selected-filters',
    'filterList' : '.inb-vert-list',
    'toggleLeftBarBtn' : '#toggle-left-bar'
  },

  events: {
    'click @ui.container #inb-selected-filters__unset' : '_unselectAllFilter',
    'click @ui.filterList li' : '_selectFilter',
    'click @ui.filterList li a.unset-filter' : '_unselectFilter',
    'click @ui.toggleLeftBarBtn' : '_toggleLeftBar'
  },

  options: {
    'filterMap' : {},
  },

  template : _.template(`
      <ul>
        <p>
          <i class="fi fi-filter"></i>
          <span id="inb-selected-filters__count">
              <%- filterCount %>
          </span>
          <%= t('filter_selected') %>
          <a href="#"
             id="inb-selected-filters__unset"
             class="unset-filter"
             title="<%= t('unselect_all_filter') %>">
              x
          </a>
        </p>
      </ul>
  `),

  initialize () {
      // Hooks for delayed components, e.g. pikaday
      this.view.options.collection.on('select:filter', this._render, this);
      this.view.options.collection.on('unselect:filter', this._render, this);
  },

  getActiveFilter () {
      const filters = this.view.collection.getFilters();
      if (this.view.collection.collectionName == 'reservationsList') {
          filters.splice(filters.indexOf("finder"), 1);
      }
      return _.filter(filters, filter => filter !== 'query' && filter !== 'q' && filter !== 'order_nbr').length;
  },

  onRender () {

      const t = this.view.t;

      this.getUI('filterList')
          .find('li')
          .each(function() {
                // TODO: remove skip and implement proper solution for reservation-status in reservationsList
                let skip = $(this).attr('data-inb-reservationList');

                if (skip == 'true') {
                    return;
                }

                $(this).html(
                    $(this).html() + '<a href="#" class="unset-filter" title="'+ t('unselect_filter') +'">x</a>'
                );
          });

      this._render();

  },

  /**
   * Renders behavior-specific template into this.getUI('container')
   */
  _render () {

      if (typeof this._ui === 'undefined') {
          // @todo A loose instance was left
          if (typeof this.view.destroy !== 'undefined') {
              this.view.destroy();
          }
      } else {

          if (this.getActiveFilter() === 0) {

              this.getUI('container').addClass('hide');

              // Reset all filter to default - except 'all'
              if (this.view.collection.collectionName == 'reservationsList') {
                // trigger event for date filter "all" (no filter)
                this.getUI('filterList')
                    .find('li.date-all')
                    .not('.active')
                    .trigger('click');
                // mark default status filter "all" as active (no status filter)
                this.getUI('filterList')
                    .find('li.status-all')
                    .addClass('active');
                // remove "x" for removing all filter (all filter are already removed)
                this.getUI('filterList')
                    .find('a.unset-filter')
                    .addClass('hide');

              } else {

                this.getUI('filterList')
                    .find('li.is-default')
                    .not('.active')
                    .trigger('click');
              }

              if (typeof this.getOption('onEmptyFilter') !== 'undefined') {
                  this.getOption('onEmptyFilter')(this.view);
              }

          } else {
              this.getUI('container').removeClass('hide');
          }
      
          this.getUI('container')
              .html(this.template({
                      filterCount: this.getActiveFilter(),
                      t: this.view.t 
                    })
              );

      }
  },

  _toggleLeftBar () {

      this.view.$el.toggleClass('open');
      $('html,body').scrollTop(0);

      if (this.view.collection.collectionName == 'reservationsList') {

        if (this.view.$el.hasClass("open")) {
            var el = $('#inb-c-main').find('.off-canvas-wrapper')[0];   // this element always exists, otherwise this function wouldn't be called
            el.style.paddingTop = this.view.el.scrollHeight + "px";
        } else {
            var el = $('#inb-c-main').find('.off-canvas-wrapper')[0];   // this element always exists, otherwise this function wouldn't be called
            el.style.paddingTop = "";
        }
      }
  
  },

  _selectFilter (el) {

      const t = $(el.currentTarget),
            ul = t.closest('ul'),
            filterKey = ul.attr('data-inb-filter'),
            filterValue = t.attr('data-inb-val');

      if (typeof filterKey === 'undefined' || typeof filterValue === 'undefined') {
          return;
      }

      if (typeof this.view.collection.getFilters[filterValue] !== 'undefined') {
          // Already selected, do nothing for now
          return;
      }

      if (typeof this.getOption('filterMap')[filterKey] !== 'undefined') {
          this.getOption('filterMap')[filterKey](this.view, filterValue);
      }

      if (typeof ul.attr('data-inb-multiple') === 'undefined') {
        if (this.view.collection.collectionName == 'reservationsList') {
            ul.find('.active').find('a.unset-filter').addClass('hide');
        }
          ul.find('.active')
            .removeClass('active');
      }

      t.addClass('active');

      if (this.view.collection.collectionName == 'reservationsList') {
          if (t.hasClass('date-all')) {
            t.find('a.unset-filter').addClass('hide');
          }
          else {
              t.find('a.unset-filter').removeClass('hide');
          }
      }
      this._render();
  },

  _unselectFilter (el) {

      let t = $(el.currentTarget).closest('li'),
          filterKey = t.closest('ul').attr('data-inb-filter');

      if (typeof filterKey === 'undefined' && typeof this.getOption('filterMap')[filterKey] === 'undefined') {
        return;
      }

      if (typeof this.getOption('unselectFilter') === 'function') {
          this.getOption('unselectFilter')(filterKey);
      }

      if (filterKey == 'from-to-date') {
        filterKey = t.attr('data-inb-val');
      }
  
      this.view.collection.removeFilter(filterKey);

      t.removeClass('active')
      .find('span') // for pikaday filter
      .html('');

      // Reset all filter in el-scope to default

      if (this.view.collection.collectionName != 'reservationsList') {
        t.closest('ul')
        .find('li.is-default')
        .trigger('click');
      } else {
          // also remove 'x' in filter list
          t.find('a.unset-filter').addClass('hide');
          console.log("click default filter 'date all'",t.closest('ul')[0].id);
          if (t.closest('ul')[0].id == 'inb-c-left-bar-flist--date-condition') {
              console.log("A");
              t.closest('ul').find('li.date-all').trigger('click');
          }
          if (t.closest('ul')[0].id == 'inb-c-left-bar-flist--reservation-status') {
              console.log("B");
              t.closest('ul').find('li.status-all').trigger('click');
          }
      }
      $('body').click(); // Else, pikaday would open

      this._render();

      return false;
  },

  _unselectAllFilter () {

      if (typeof this.getOption('unselectAllFilter') === 'function') {
          this.getOption('unselectAllFilter')(this.view);
      }

      if (this.view.collection.collectionName == 'reservationsList' && typeof this.view.collection.resetFiltersKeepQuery !== 'undefined') {
        this.view.collection.resetFiltersKeepQuery(false);
        this.view.collection._filterParams['finder'] = 'NotCancelled';
        this.view.collection.addFilter('finder','NotCancelled');
      } else if (typeof this.view.collection.resetFiltersKeepQuery !== 'undefined') {
        this.view.collection.resetFiltersKeepQuery(false);
      } else {
          // Although the following is actually a bug in all proxy-collections
          // as "query" - which is a filter as well, but located in AccessBar -
          // becomes resetted as well :(
          this.view.collection.resetFilters();
      }

      this.getUI('filterList')
          .find('li.active')
          .removeClass('active');

      if (this.$el.hasClass('open')) {
          // For mobile devices
          this._toggleLeftBar();
      }

      this.view.$el.find('.select2-selection__choice__remove')
                  .trigger('click');

      this._render();

      return false;
  }

});
